import axios from 'axios';
import {
  req
} from './axiosFun';


//会话列表
export const list = (params) => {
  return req("get", "/api/auth/jim/message/conversation?page=" + params.page + '&keyword=' + params
    .keyword + '&info=' + params.info)
};


//表情列表
export const getEmojis = () => {
  return req("get", "/api/auth/jim/message/emojis")
};


//表情列表
export const chat = () => {
  return req("get", "/api/auth/jim/message/chat-index")
};


//消息列表
export const getlistMsg = (params) => {
  return req("get", "/api/auth/jim/message/listMsg?page=" + params.page + '&rows=' + params
    .rows + '&oneUserId=' + params.oneUserId + '&twoUserId=' + params.twoUserId)
};

//上传图片
export const uploadImg = (param) => {
  let config = {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  }; //添加请求头
 return axios.post('/api/common/file/image/upload', param, config).then(response => {
    console.log(response.data);
    return Promise.resolve(response.data);
  }).catch((err) => {
    return Promise.reject(err);
  });
};



// WEBPACK FOOTER //
// ./src/api/customer.js